import React from "react";

const DescriptionText = ({
  description,
  defaultData,
  customClass,
  descriptionColour,
  descriptionStatus = false,
}) => {
  return (
    <div
      className={`mt-16 landingDescription mb-16 text-break ${
        customClass ? customClass : ""
      } ${!descriptionStatus ? "d-none" : ""}`}
      style={{
        color:
          descriptionColour !== ""
            ? descriptionColour
            : defaultData.descriptionColour,
      }}
    >
      {description !== "" ? description : defaultData.description}
    </div>
  );
};

export default DescriptionText;
